import { createApp } from "vue";
import { createPinia } from "pinia";
import MovieListing from "./vue/MovieListing.vue";
import FilterBar from "./vue/components/FilterBar.vue";
import MovieBlock from "./vue/components/MovieBlock.vue";
import TableView from "./vue/components/TableView.vue";
import CalendarView from "./vue/components/CalendarView.vue";
import TrailerPlayer from "./vue/components/TrailerPlayer.vue";

// Create shared Pinia instance for all apps
const pinia = createPinia();

try {
  // Function to initialize Vue components
  const initVueComponents = () => {
    const movieListingEl = document.querySelector("#movielisting");
    const filterContainerEl = document.querySelector("#filterbar");
    const trailerPlayerEl = document.querySelector("#trailerplayer");

    if (movieListingEl) {
      const movielisting = createApp(MovieListing);
      movielisting.use(pinia);
      movielisting.component("MovieBlock", MovieBlock);
      movielisting.component("TableView", TableView);
      movielisting.component("CalendarView", CalendarView);
      movielisting.mount("#movielisting");
    }

    if (filterContainerEl) {
      const filterbar = createApp(FilterBar);
      filterbar.use(pinia);
      filterbar.mount("#filterbar");
    }

    if (trailerPlayerEl) {
      const trailerplayer = createApp(TrailerPlayer);
      trailerplayer.use(pinia);
      trailerplayer.mount("#trailerplayer");
    }
  };

  // Handler for old Blade PHP play buttons with data-slug attribute
  const handleBladePlayButtons = () => {
    // Listen for clicks on play buttons with data-slug attribute
    document.addEventListener("click", async (event) => {
      const playButton = event.target.closest(".play-button[data-slug]");

      if (!playButton) return;

      event.preventDefault();
      const slug = playButton.getAttribute("data-slug");
      if (!slug) return;

      try {
        // Fetch movie data from API
        const response = await fetch(
          `/programm/api/filtered-films?slugs=${encodeURIComponent(slug)}`,
        );
        if (!response.ok) {
          console.error("Failed to fetch movie data");
          return;
        }

        const data = await response.json();

        if (!data.films || data.films.length === 0) {
          console.error("No movie data found for slug:", slug);
          return;
        }

        const movie = data.films[0];

        // Dispatch the trailerplayer-play event that TrailerPlayer listens for
        const trailerEvent = new CustomEvent("trailerplayer-play", {
          detail: movie,
          bubbles: true,
        });
        document.dispatchEvent(trailerEvent);
      } catch (error) {
        console.error("Error handling play button click:", error);
      }
    });
  };

  // Initialize when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      initVueComponents();
      handleBladePlayButtons();
    });
  } else {
    // DOM is already ready
    initVueComponents();
    handleBladePlayButtons();
  }
} catch (error) {
  console.error(error);
}
